import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  CheckboxField,
  Flex,
  Button,
} from '@aws-amplify/ui-react';
import { Controller, useForm } from 'react-hook-form';
import { useProfileGetByUsernameQuery } from '../profile/api/useProfileQuery';
import { useNavigate } from 'react-router-dom';
import { useCareGiverPostMutation } from './api/useCareGiversMutation';
import { useUserQuery } from '../common/useUserQuery';

export default function CareGiverSearchResults({ searchUsername }) {
  const { data: userQueryData } = useUserQuery();

  const { data: caregiverData, isLoading } =
  useProfileGetByUsernameQuery(searchUsername);
  const { mutate: careGiverPostMutation } = useCareGiverPostMutation();

  const { control, handleSubmit, reset } = useForm();
  const navigate = useNavigate();

  const onSubmit = (values) => {
    for (const [key, value] of Object.entries(values)) {
      if (value === true) {
        console.log(`${key}: ${value}`);
        careGiverPostMutation({
          patientUserId: userQueryData?.patientUserId,
          caregiverUserId: key,
        });
        navigate('/user/hr/caregivers');
      }
    }
  };

  if (isLoading) {
    <div>Loading...</div>;
  }

  if (caregiverData == null) {
    return <div>Nothing found...</div>;
  }

  if (caregiverData != null) {
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex direction={'column'}>
          <Flex gap={9}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell as="th">Select</TableCell>
                  <TableCell as="th">Given Name</TableCell>
                  <TableCell as="th">Username</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Controller
                      name={caregiverData?.patientUserId || ''}
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <CheckboxField
                          {...field}
                          value={field.value || false}
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell>{caregiverData?.givenName}</TableCell>
                  <TableCell>{caregiverData?.username}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Flex>
          <Flex gap={9}>
            <Button variation="primary" children="Add" type="submit" />
          </Flex>
        </Flex>
      </form>
    );
  }
}
